// ── className 팩토리 함수들 (Tailwind 기반) ────────────────────────────────
import { cn } from '../../../lib/utils';

/**
 * 아이콘 버튼 className 반환
 * type: 'edit' | 'del' | 'ok' | 'cancel' | 'add'
 * extra: 추가 클래스 (선택)
 */
export function ib(type, extra) {
  const base = 'border-none cursor-pointer rounded px-1 py-px text-[10px] font-bold flex-shrink-0 leading-[1.4] inline-flex items-center';
  const v = {
    edit:   'bg-transparent text-slate-400 hover:text-slate-600',
    del:    'bg-transparent text-red-400 hover:text-red-500',
    ok:     'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400',
    cancel: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
    add:    'bg-slate-900 dark:bg-accent-600 text-white px-2 py-0.5 rounded-md',
  };
  return cn(base, v[type] || '', extra);
}

// (catTypeBadge — 카테고리 내부/외부 배지. 쓰는 곳이 하나도 없어 제거, 2026-09-20)

/**
 * 유효기간 배지 className
 * hasVal: 유효기간이 설정된 경우 강조색, 없으면 회색
 */
export function validityBadge(hasVal) {
  return cn(
    'text-[11px] font-bold px-[7px] py-0.5 rounded-md flex-shrink-0 cursor-pointer border transition-colors duration-100',
    hasVal
      ? 'bg-accent-50 text-accent-600 border-accent-200 dark:bg-pine-800 dark:text-accent-300'
      : 'bg-[var(--bg-subtle)] text-slate-300 dark:text-slate-600 border-[var(--border)]',
  );
}

// (personChip/dot 은 미팅지도 관리 SettingsInheritPanel 로 이관 — 2026-09-01)
